import { Component, OnInit, Input } from '@angular/core';
import { BarContainer } from '../../../models/cabiancaChart.model';

@Component({
  selector: 'app-slotbar',
  templateUrl: './slotbar.component.html',
  styleUrls: ['./slotbar.component.css']
})
export class SlotbarComponent implements OnInit {
  @Input() bar: BarContainer
  @Input() type: string
  @Input() typeChart: string
  totalSection : number
  constructor() { }

  ngOnInit() {

if (this.bar != null && this.bar.active && this.type == 'allsite'){
  //debugger
}

    if (this.type == 'allsite' && this.typeChart == 'engagement'){
      if (this.bar.sections.length > 1)
        this.totalSection = this.bar.sections[0].value + this.bar.sections[1].value
      else if (this.bar.sections.length > 0)
        this.totalSection = this.bar.sections[0].value
    }
  }

}
